import React from 'react';
import { PeekDialogContent, PeekDialogContentText, PeekBox, PeekAutocomplete } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import { NodeLinkType } from '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../../../utils/ErrorProvider.js';
import '../../../../../utils/LoaderProvider.js';
import '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import 'tslib';
import { getUniqueTimeStampId } from '../../../../../utils/getUniqueId.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';

const SceneHotspot = ({ onHotspotCreation }) => {
    const { details, getScene } = usePannellumViewer();
    const currentSceneID = getScene();
    const handleSceneSelection = (event, node) => {
        const hotspot = {
            _id: getUniqueTimeStampId("hotspot"),
            label: node.label,
            type: NodeLinkType.Node,
            rotation: {
                pitch: 0,
                yaw: 0,
            },
            node: node._id,
        };
        onHotspotCreation(hotspot, node._id);
    };
    return (React.createElement(PeekDialogContent, null,
        React.createElement(PeekDialogContentText, { fontWeight: "fontWeightBold", color: "primary" }, "Select a room to link to"),
        React.createElement(PeekBox, { height: 300 },
            React.createElement(PeekAutocomplete, { freeSolo: false, disablePortal: true, popupIcon: null, options: details.nodes.filter((node) => node._id !== currentSceneID), onChange: handleSceneSelection, getOptionLabel: (option) => option.label, open: true }))));
};

export { SceneHotspot, SceneHotspot as default };
